import Vue from 'vue'
import Router from 'vue-router'

import AuthService from '@/auth/AuthService'
import { store } from '@/store/store'
import userService from '@/services/userService'

//routes
import defaultRoutes from './default'

Vue.use(Router)

function withNavigationDuplicateGuard (methodName) {
    const original = Router.prototype[methodName]

    Router.prototype[methodName] = function patchedNavigation (location, onResolve, onReject) {
        if (onResolve || onReject) {
            return original.call(this, location, onResolve, onReject)
        }

        return original.call(this, location).catch(error => {
            if (error && error.name === 'NavigationDuplicated') {
                return error
            }

            return Promise.reject(error)
        })
    }
}

withNavigationDuplicateGuard('push')
withNavigationDuplicateGuard('replace')

const auth = new AuthService()

const router = new Router({
    mode: 'history',
    routes: [
        defaultRoutes
    ]
})

function userHasRoleList () {
    let coronerUserDto = store.state.auth.coronerUserDto || {}
    //check if user has roleList or not
    return !!(coronerUserDto.roleList && coronerUserDto.roleList.length > 0)
}

function hasAdminAccess () {
    let coronerUserDto = store.state.auth.coronerUserDto || {}
    return userService.isAdministrator(coronerUserDto.roleList)
}

function hasCountyAdminAccess () {
    let coronerUserDto = store.state.auth.coronerUserDto || {}
    return userService.isAdminCountyAdmin(coronerUserDto.roleList)
}

function hasCoronerAccess () {
    let coronerUserDto = store.state.auth.coronerUserDto || {}
    return userService.isAdministrator(coronerUserDto.roleList) || userService.isCoroner(coronerUserDto.roleList)
}

function hasUserDto () {
    return !!store.state.auth.coronerUserDto
}

//auth behavior
router.beforeEach((to, from, next) => {
    //if path requiresAuth, do check
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!auth.isAuthenticated()) {
            //auth.logout()
            store.dispatch('logout')
            alert('Your login session is timed out/ended.')
            next({ path: '/logout' })
            return
        }
        if (!hasUserDto()) {
            next(from)
            return
        }
        if (!userHasRoleList()) {
            alert('Cannot obtain user role.')
            next({ path: '/userprofile' })
            return
        }
        if (to.matched.some(record => record.meta.requiresAdmin && !hasAdminAccess())) {
            alert('User does not have access, returning to Home.')
            next({ path: '/home' })
            return
        }
        if (to.matched.some(record => record.meta.requiresCountyAdmin && !hasCountyAdminAccess())) {
            alert('User does not have access, returning to Home.')
            next({ path: '/home' })
            return
        }
        if (to.matched.some(record => record.meta.requiresCoroner && !hasCoronerAccess())) {
            alert('User does not have access, returning to Home.')
            next({ path: '/home' })
            return
        }
        next()
    } else {
        next()
    }
})
export default router
